import { UpOutlined } from "@ant-design/icons";
import { Container, GoUpButton, LeftContainer, RightContainer, VersionTitle } from "./styled";

const SubFooterComponent = () => {
    return (
        <Container>
            <LeftContainer>
                {/* <ImgContent src={SubFooterImg} /> */}
                <VersionTitle>Release 1.0.0.2</VersionTitle>
            </LeftContainer>
            <RightContainer><GoUpButton><UpOutlined color="#575757" /></GoUpButton></RightContainer>
        </Container>
    );
};

export default SubFooterComponent;